import { Box, Skeleton } from "@mui/material";

export default function PositiveOrNegetiveSTSkeleton({
  rows = 8,
  columns = 6,
}) {
  return (
    <Box sx={{ width: "100%", mt: 1 }}>
      <Box sx={{ display: "flex", gap: 1, mb: 1 }}>
        {[...Array(columns)].map((_, i) => (
          <Skeleton
            key={i}
            variant="rectangular"
            height={32}
            width={`${100 / columns - 1}%`}
            sx={{ borderRadius: 1 }}
          />
        ))}
      </Box>

      {[...Array(rows)].map((_, rowIdx) => (
        <Box
          key={rowIdx}
          sx={{
            display: "flex",
            gap: 1,
            mb: 1,
          }}
        >
          {[...Array(columns)].map((_, colIdx) => (
            <Skeleton
              key={colIdx}
              variant="rectangular"
              height={28}
              width={`${100 / columns - 1}%`}
              sx={{ borderRadius: 1 }}
            />
          ))}
        </Box>
      ))}
    </Box>
  );
}
